import { css } from "@emotion/react";
import { AnimatePresence } from "framer-motion";
import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { Wrapper } from "../../base";
import LoadingBlock from "../LoadingBlock";

const HomePage = lazy(() => import("../../pages/HomePage"));
const AccountModal = lazy(() => import("../AccountModal"));
const BlockModal = lazy(() => import("../BlockModal"));
const GraphSwitcher = lazy(() => import("../Graph"));
const MetricsModal = lazy(() => import("../MetricsModal/MetricsModal"));
const MoveModal = lazy(() => import("../MoveModal"));
const SupplyModal = lazy(() => import("../SupplyModal"));
const WelcomeModal = lazy(() => import("../WelcomeModal"));

const MainRoute = () => (
  <>
    <Wrapper
      contentCss={css`
        position: relative;
      `}
    >
      <Route path={["/explore/:type/:slug", "/welcome", "/"]}>
        <Suspense>
          <HomePage />
        </Suspense>
      </Route>

      <Switch>
        <Route
          path="/welcome"
          render={() => (
            <Suspense>
              <WelcomeModal />
            </Suspense>
          )}
        />

        <Route
          path="/metrics"
          render={() => (
            <Suspense>
              <MetricsModal />
            </Suspense>
          )}
        />

        <Route path="/account">
          <Suspense>
            <AccountModal
              css={css`
                position: absolute;
                right: 0;
                top: 1rem;
                width: 28.5rem;
                z-index: 1;
              `}
            />
          </Suspense>

          <Route
            render={({ location }) => (
              <AnimatePresence>
                <Switch key={location.pathname} location={location}>
                  <Route path="/account/supply">
                    <Suspense>
                      <SupplyModal />
                    </Suspense>
                  </Route>

                  <Route path="/account/move/:appId">
                    <React.Suspense fallback={<LoadingBlock />}>
                      <MoveModal />
                    </React.Suspense>
                  </Route>
                </Switch>
              </AnimatePresence>
            )}
          />
        </Route>

        <Route path="/blocked">
          <Suspense>
            <BlockModal />
          </Suspense>
        </Route>
      </Switch>
    </Wrapper>

    <Route path={["/explore/:type/:slug", "/"]}>
      <Suspense>
        <GraphSwitcher />
      </Suspense>
    </Route>
  </>
);

export default MainRoute;
